var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtisteYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 44,
    viewBox: "0 0 60 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "artiste_yt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_794_1071",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 60,
    height: 43
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.02734H60V43.2514H0V1.02734Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_794_1071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7458 7.62022C58.0555 5.02537 56.0216 2.98117 53.4388 2.28753C48.7574 1.02734 29.9853 1.02734 29.9853 1.02734C29.9853 1.02734 11.2137 1.02734 6.53228 2.28753C3.94946 2.98117 1.91561 5.02537 1.2253 7.62022C-0.0292969 12.3248 -0.0292969 22.1391 -0.0292969 22.1391C-0.0292969 22.1391 -0.0292969 31.954 1.2253 36.6581C1.91561 39.2529 3.94946 41.2976 6.53228 41.9908C11.2137 43.2514 29.9853 43.2514 29.9853 43.2514C29.9853 43.2514 48.7574 43.2514 53.4388 41.9908C56.0216 41.2976 58.0555 39.2529 58.7458 36.6581C60.0004 31.954 60.0004 22.1391 60.0004 22.1391C60.0004 22.1391 60.0004 12.3248 58.7458 7.62022Z",
    fill: "#D9252A"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0879 30.6961L40.1589 21.9052L25.0879 13.1133V30.6961Z",
    fill: "#FFFFFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtisteYt);
export default __webpack_public_path__ + "static/media/artiste_yt.05bdf96f2e35eb30d8bb1c84c89511c0.svg";
export { ForwardRef as ReactComponent };